import { render, staticRenderFns } from "./objectCollectionConfig.vue?vue&type=template&id=66a598ea"
import script from "./objectCollectionConfig.vue?vue&type=script&lang=js"
export * from "./objectCollectionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports